<template>
    <v-container fluid>
        <!-- Breadcrumbs -->
        <v-breadcrumbs
            :items="[{text: 'Home', disable: false, href: '/#/'}, {text: 'Inventory', disabled: true}]"
            divider="/"
        ></v-breadcrumbs>

        <v-row class="ma-0">
            <v-col cols="12" class="pt-0">
                <v-hover>
                    <template v-slot="{ hover }">
                        <v-card :elevation="hover ? 6 : 1">
                            <v-card-title class="pb-0">
                                <v-icon color="primary" class="ml-2 mr-2">storefront</v-icon>Inventory
                                <v-spacer></v-spacer>
                                <v-col cols="12" sm="4">
                                    <v-text-field
                                        dense
                                        v-model="search"
                                        append-outer-icon="refresh"
                                        @click:append-outer="refreshCurrentPage()"
                                        label="Search"
                                        clearable
                                        hide-details
                                        @keydown.enter="refreshCurrentPage()"
                                        @click:clear="onClearSearch()"
                                    ></v-text-field>
                                </v-col>
                                <v-spacer></v-spacer>
                                <vue-excel-xlsx
                                    :fetch="userRequestExcel"
                                    :columns="columnsExcel"
                                    :file-name="'InventoryExport'"
                                    :file-type="'xlsx'"
                                    :sheet-name="'sheetname'"
                                    >
                                        <v-btn 
                                        small
                                        outlined
                                        color="primary"
                                        rounded
                                        class="mx-0 mb-3"
                                        dense
                                        :disabled="tenantGrowthTaskInventoryByPlants && tenantGrowthTaskInventoryByPlants.edges && tenantGrowthTaskInventoryByPlants.edges.length > 0 ? false : true "
                                        :loading="isExportingExcel">
                                            Download
                                        </v-btn>
                                </vue-excel-xlsx>
                            </v-card-title>

                            <v-container fluid>
                                <v-data-table
                                    :headers="headers"
                                    :loading="$apollo.queries.tenantGrowthTaskInventoryByPlants.loading"
                                    :items="tenantGrowthTaskInventoryByPlants.edges"
                                    :options.sync="dataTableOptions"
                                    :server-items-length="tenantGrowthTaskInventoryByPlants.totalCount"
                                    loading-text="Loading... Please wait"
                                    :items-per-page="defaultItemsPerPage"
                                    :footer-props="{
                                                    'items-per-page-options': [10,25,50,75,100],
                                                    'disable-pagination': $apollo.queries.tenantGrowthTaskInventoryByPlants.loading
                                                    }"
                                >
                                    <template v-slot:item.node.potSize.potSizeCm="{ item }">
                                        <span>{{ item.node.potSize.potSizeCm }} cm</span>
                                    </template>
                                    <template v-slot:item.node.inventoryReadySales="{ item }">
                                        <span>{{ item.node.inventoryReadySales }}</span>
                                        <span
                                            v-if="item.node.inventoryReadySalesLocked > 0"
                                            class="ml-2 error--text"
                                        >({{ item.node.inventoryReadySalesLocked }} locked)</span>
                                    </template>
                                </v-data-table>
                            </v-container>
                        </v-card>
                    </template>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "inventory-list",
    components: {},

    apollo: {
        tenantGrowthTaskInventoryByPlants: {
            query: gql`
                query tenantGrowthTaskInventoryByPlants(
                    $first: Int
                    $last: Int
                    $before: String
                    $after: String
                    $search: String
                    $orderBy: String
                ) {
                    tenantGrowthTaskInventoryByPlants(
                        first: $first
                        last: $last
                        before: $before
                        after: $after
                        search: $search
                        orderBy: $orderBy
                    ) {
                        edgeCount
                        totalCount
                        pageInfo {
                            startCursor
                            endCursor
                            hasPreviousPage
                            hasNextPage
                        }
                        edges {
                            node {
                                id
                                plant {
                                    id
                                    name
                                    plantSpecies {
                                        id
                                        name
                                    }
                                }
                                potSize {
                                    id
                                    potSizeCm
                                }
                                color {
                                    id
                                    color
                                }
                                environment {
                                    id
                                    environment
                                }
                                tag {
                                    id
                                    tag
                                }
                                inventoryReadySales
                                inventoryReadySalesLocked
                                inventoryWeek1
                                inventoryWeek2
                                inventoryWeek3AndAfter
                            }
                        }
                    }
                }
            `,
            variables() {
                return {
                    first: 10
                };
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => data.tenantGrowthTaskInventoryByPlants,
            skip: true,
            pollInterval: 60000 // ms
        }
    },

    data: function() {
        return {
            isLoadingInventory: false,

            search: "",
            isExportingExcel: false,
            defaultItemsPerPage: 25,
            dataTableOptions: {},
            page: 1,

            tenantGrowthTaskInventoryByPlants: {},

            columnsExcel: [
                {
                    label: "Plant Species",
                    field: "node.plant.plantSpecies.name",
                },
                {
                    label: "Plant",
                    field: "node.plant.name",
                },
                {
                    label: "Pot Size",
                    field: "node.potSize.potSizeCm",
                },
                {
                    label: "Color",
                    field: {
                        callback : (value) => {
                            if(value.node.color != null)
                                return value.node.color.color
                        }
                    }
                },
                {
                    label: "Environment",
                    field: {
                        callback : (value) => {
                            if(value.node.environment != null)
                                return value.node.environment.environment
                        }
                    }
                },
                {
                    label: "Tag",
                    field: {
                        callback : (value) => {
                            if(value.node.tag != null)
                                return value.node.tag.tag
                        }
                    }
                },
                {
                    label: "Sales",
                    field: "node.inventoryReadySales",
                },
                {
                    label: "Week 1",
                    field: "node.inventoryWeek1",
                },
                {
                    label: "Week 2",
                    field: "node.inventoryWeek2",
                },
                {
                    label: "Week 3+",
                    field: "node.inventoryWeek3AndAfter",
                }
            ],

            headers: [
                {
                    text: "Plant Species",
                    value: "node.plant.plantSpecies.name",
                    sortable: true
                },
                {
                    text: "Plant",
                    align: "left",
                    value: "node.plant.name",
                    sortable: true
                },
                {
                    text: "Pot Size",
                    value: "node.potSize.potSizeCm",
                    sortable: true
                },
                {
                    text: "Color",
                    value: "node.color.color",
                    sortable: true
                },
                {
                    text: "Environment",
                    value: "node.environment.environment",
                    sortable: true
                },
                {
                    text: "Tag",
                    value: "node.tag.tag",
                    sortable: true
                },
                {
                    text: "Sales",
                    value: "node.inventoryReadySales",
                    sortable: true
                },
                {
                    text: "Week 1",
                    value: "node.inventoryWeek1",
                    sortable: true
                },
                {
                    text: "Week 2",
                    value: "node.inventoryWeek2",
                    sortable: true
                },
                {
                    text: "Week 3+",
                    value: "node.inventoryWeek3AndAfter",
                    sortable: true
                }
            ],
            editedIndex: -1
        };
    },
    computed: {
        // inventory: function() {
        //     return this.$store.state.inventory.inventory;
        // }
    },
    watch: {
        dataTableOptions: {
            handler() {
                this.refreshCurrentPage();
            },
            deep: true
        }
    },
    created() {
        this.initialize();
    },
    methods: {
        initialize() {
            // this.fetchInventory();
        },
        async userRequestExcel() {
            this.isExportingExcel = true;

            var _first = 1000;
            var _before = null;
            var _after = null;
            var _last = null;
            var _orderBy = null;

            const {
                sortBy,
                sortDesc,
            } = this.dataTableOptions;

            switch (sortBy[0]) {
                case "node.plant.plantSpecies.name":
                    _orderBy = "plantSpeciesName";
                    break;
                case "node.plant.name":
                    _orderBy = "plantName";
                    break;
                case "node.potSize.potSizeCm":
                    _orderBy = "potSize";
                    break;
                case "node.color.color":
                    _orderBy = "color";
                    break;
                case "node.environment.environment":
                    _orderBy = "environment";
                    break;
                case "node.tag.tag":
                    _orderBy = "tag";
                    break;
                case "node.inventoryReadySales":
                    _orderBy = "inventoryReadySales";
                    break;
                case "node.inventoryWeek1":
                    _orderBy = "inventoryWeek1";
                    break;
                case "node.inventoryWeek2":
                    _orderBy = "inventoryWeek2";
                    break;
                case "node.inventoryWeek3AndAfter":
                    _orderBy = "inventoryWeek3AndAfter";
                    break;
                default:
                    _orderBy = null;
                    break;
            }

            if (sortDesc[0] === true) {
                _orderBy = "-" + _orderBy;
            }

            const result = this.$apollo
                .query({
                    // Query
                    query: gql`
                        query tenantGrowthTaskInventoryByPlants(
                            $first: Int
                            $last: Int
                            $before: String
                            $after: String
                            $search: String
                            $orderBy: String
                        ) {
                            tenantGrowthTaskInventoryByPlants(
                                first: $first
                                last: $last
                                before: $before
                                after: $after
                                search: $search
                                orderBy: $orderBy
                            ) {
                                edgeCount
                                totalCount
                                pageInfo {
                                    startCursor
                                    endCursor
                                    hasPreviousPage
                                    hasNextPage
                                }
                                edges {
                                    node {
                                        id
                                        plant {
                                            id
                                            name
                                            plantSpecies {
                                                id
                                                name
                                            }
                                        }
                                        potSize {
                                            id
                                            potSizeCm
                                        }
                                        color {
                                            id
                                            color
                                        }
                                        environment {
                                            id
                                            environment
                                        }
                                        tag {
                                            id
                                            tag
                                        }
                                        inventoryReadySales
                                        inventoryReadySalesLocked
                                        inventoryWeek1
                                        inventoryWeek2
                                        inventoryWeek3AndAfter
                                    }
                                }
                            }
                        }
                    `,
                    variables: {
                        first: _first,
                        last: _last,
                        before: _before,
                        after: _after,
                        orderBy: _orderBy,
                        search: this.search,
                    },
                    fetchPolicy: "network-only"
                })
                .then(response => {
                    return response.data.tenantGrowthTaskInventoryByPlants.edges;
                })
                .catch(error => {
                    // Error
                    console.error(error);
                })
                .finally(() => {
                    // this.isSavingOrderPrintStatus = false;
                    this.isExportingExcel = false;
                });
            return result;
        },

        // fetchInventory() {
        //     // fetch plants
        //     this.isLoadingInventory = true;
        //     this.$store
        //         .dispatch("inventory/fetchGrowthTaskInventoryByPlant")
        //         .then(() => {
        //             // console.log("Fetched plants");
        //             // this.snackbarText = `${this.plants.length} plants fetched!`;
        //             // this.snackbar = true;
        //         })
        //         .catch(error => {
        //             /*handle errors*/
        //             console.log(error);
        //         })
        //         .finally(() => (this.isLoadingInventory = false));
        // }

        onClearSearch() {
            this.search = "";

            this.refreshCurrentPage();
        },

        refreshCurrentPage() {
            const {
                sortBy,
                sortDesc,
                page,
                itemsPerPage
            } = this.dataTableOptions;

            // console.log(sortBy, sortDesc, page, itemsPerPage);

            var _first = itemsPerPage;
            var _last = null;
            var _before = null;
            var _after = null;
            var _orderBy = null;

            if (page < this.page) {
                _first = null;
                _last = itemsPerPage;
                _before = this.tenantGrowthTaskInventoryByPlants.pageInfo
                    .startCursor;
                _after = null;
            }

            if (page > this.page) {
                _first = itemsPerPage;
                _last = null;
                _before = null;
                _after = this.tenantGrowthTaskInventoryByPlants.pageInfo
                    .endCursor;
            }

            switch (sortBy[0]) {
                case "node.plant.plantSpecies.name":
                    _orderBy = "plantSpeciesName";
                    break;
                case "node.plant.name":
                    _orderBy = "plantName";
                    break;
                case "node.potSize.potSizeCm":
                    _orderBy = "potSize";
                    break;
                case "node.color.color":
                    _orderBy = "color";
                    break;
                case "node.environment.environment":
                    _orderBy = "environment";
                    break;
                case "node.tag.tag":
                    _orderBy = "tag";
                    break;
                case "node.inventoryReadySales":
                    _orderBy = "inventoryReadySales";
                    break;
                case "node.inventoryWeek1":
                    _orderBy = "inventoryWeek1";
                    break;
                case "node.inventoryWeek2":
                    _orderBy = "inventoryWeek2";
                    break;
                case "node.inventoryWeek3AndAfter":
                    _orderBy = "inventoryWeek3AndAfter";
                    break;
                default:
                    _orderBy = null;
                    break;
            }

            if (sortDesc[0] === true) {
                _orderBy = "-" + _orderBy;
            }

            this.$apollo.queries.tenantGrowthTaskInventoryByPlants.setVariables(
                {
                    first: _first,
                    last: _last,
                    before: _before,
                    after: _after,
                    orderBy: _orderBy,
                    search: this.search
                }
            );

            // set skip false to execute the query
            this.$apollo.queries.tenantGrowthTaskInventoryByPlants.skip = false;
            this.$apollo.queries.tenantGrowthTaskInventoryByPlants.refresh();

            // update this.page
            this.page = page;
        }
    }
};
</script>